import { useMemo } from 'react'
import BookingDetailsResortPackage from './BookingDetailsResortPackage'
import BookingDetailsLiveaboardPackage from './BookingDetailsLiveaboardPackage'

const BookingDetailsPackage = ({ order, guestsInRoom, isCheckout }) => {
  const { shopKind } = order

  return useMemo(() => {
    switch (shopKind) {
      case 10:
        return <BookingDetailsLiveaboardPackage order={order} isCheckout={isCheckout} />
      case 20:
        return (
          <BookingDetailsResortPackage
            order={order}
            guestsInRoom={guestsInRoom}
          />
        )
      default:
        return null
    }
  }, [shopKind, order])
}

export default BookingDetailsPackage
